import { render, staticRenderFns } from "./inbound-call-voicemail-icon.vue?vue&type=template&id=3871c519"
import script from "./inbound-call-voicemail-icon.vue?vue&type=script&lang=js"
export * from "./inbound-call-voicemail-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports